// Anita Week 7 / Day 1 — Профессии и помощники / Professions and Helpers
// U.S. Grade 3 upgrade for Week 7 (Business: Professions/Work/Value).

const day1 = {
  id: 'day-1',
  studentId: 'anita',
  weekId: 'week-7',
  dayId: 'day-1',
  status: 'active',
  title: 'Профессии и помощники / Professions and Helpers',
  shortTitle: 'Профессии / Professions',
  theme: 'Анита учится видеть, кто и как помогает людям. / Anita learns who helps people and how.',
  estimatedTimeLabel: '60–90 минут / 60–90 minutes',
  lessonTiming: { minMinutes: 60, maxMinutes: 90, breaks: 2 },
  bilingualMode: 'ru-primary-en-helper',
  courseLayers: ['reading', 'math', 'business-thinking', 'professions', 'logic', 'spelling', 'creative', 'speech'],
  readingLevel: 'grade-2',
  nimnyIntro: 'Нимни ведёт Аниту в мастерскую помощников. / Nimny leads Anita to the helpers workshop.',
  goals: [
    'Понять слова: врач, учитель, мастер, помощь.',
    'Решить задачи Grade-3: умножение, деление, сложение.',
    'Провести логику: сломался велосипед.',
    'Написать слова темы и объяснить родителю.'
  ],
  vocabulary: [
    { term: 'профессия / profession', definition: 'дело, которое помогает людям. / work that helps people.' },
    { term: 'врач / doctor', definition: 'человек, который лечит людей. / a person who treats people.' },
    { term: 'учитель / teacher', definition: 'человек, который учит детей. / a person who teaches children.' },
    { term: 'мастер / master', definition: 'человек, который умеет чинить и делать вещи. / a person who fixes and makes things.' },
    { term: 'помощь / help', definition: 'действие, которое делает легче другому. / an action that makes it easier for someone.' },
    { term: 'навык / skill', definition: 'умение делать что-то хорошо. / an ability to do something well.' }
  ],
  onlineTasks: [
    { id: 'reading-words', type: 'text', title: 'Задание 1 — Слова темы',
      prompt: 'Прочитай по-русски:\nпрофессия\nврач\nучитель\nмастер\nпомощь\nнавык',
      ruPrimaryText: 'Прочитай 6 слов темы.', enHelpText: 'Read 6 theme words.', answer: 'Попытка чтения.' },
    { id: 'reading-sentences', type: 'text', title: 'Задание 2 — Маленькое чтение',
      prompt: 'Прочитай по-русски:\nВрач лечит людей.\nУчитель учит детей.\nМастер чинит вещи.\nКаждая профессия даёт пользу.',
      ruPrimaryText: 'Прочитай 4 фразы.', enHelpText: 'A doctor heals, a teacher teaches, a master fixes.', answer: 'Попытка чтения.' },
    { id: 'workshop-helpers', type: 'text', title: 'Задание 3 — Мастерская помощников',
      prompt: 'В мастерской помощников работают врач, учитель и мастер.\nВрач лечит, учитель учит, мастер чинит.\n\nОтветь:\n1. Кто из них помогает, когда ребёнок болеет?\n2. Кто помогает, когда трудно с уроками?\n3. Кто помогает, когда сломался велосипед?',
      ruPrimaryText: 'Соотнеси профессию и ситуацию.', enHelpText: 'Match doctor/teacher/master to situations.', answer: '1) врач. 2) учитель. 3) мастер.' },
    { id: 'help-home-school-friends', type: 'text', title: 'Задание 4 — Помощь дома, школе, друзьям',
      prompt: 'Анита помогает дома 18 минут, в школе 22 минуты и друзьям 15 минут.\n\nОтветь:\n1. Сколько всего минут помощи?\n2. За час (60 минут) сколько осталось свободных минут?',
      ruPrimaryText: 'Реши по шагам (математика Grade 3).', enHelpText: 'Math: multi-step sum.', answer: '18 + 22 + 15 = 55; 60 − 55 = 5 минут.' },
    { id: 'helper-work-time', type: 'text', title: 'Задание 5 — Время работы помощника',
      prompt: 'Мастер чинит 4 велосипеда, каждый ремонт 7 минут.\nПотом Анита помогла и работа закончилась на 5 минут раньше.\n\nОтветь:\n1. Сколько минут без помощи?\n2. Сколько минут получилось с помощью Аниты?',
      ruPrimaryText: 'Реши по шагам.', enHelpText: 'Grade-3 multi-step.', answer: '4 × 7 = 28; 28 − 5 = 23 минуты.' },
    { id: 'three-professions-cards', type: 'text', title: 'Задание 6 — 3 профессии по 6 карточек',
      prompt: 'Анита делает по 6 карточек навыков для 3 профессий.\nВсего у Нимни 36 карточек.\n1/3 карточек — про врача, 1/4 карточек — про учителя, остальные — про мастера.\n\nОтветь:\n1. Сколько всего карточек делает Анита?\n2. Сколько карточек про врача?\n3. Сколько про учителя?\n4. Сколько про мастера?',
      ruPrimaryText: 'Реши по шагам.', enHelpText: 'Multi-step ×, ÷, fractions.', answer: '3 × 6 = 18; 36 ÷ 3 = 12; 36 ÷ 4 = 9; 36 − 12 − 9 = 15.' },
    { id: 'logic-broken-bike', type: 'text', title: 'Задание 7 — Логика: сломался велосипед',
      prompt: 'У Аниты сломался велосипед. Кого позвать первым: врача, учителя или мастера? Почему?\nОтветь 1–3 предложениями.',
      ruPrimaryText: 'Логика: кого позвать первым.', enHelpText: 'Logic: whom to call first.', answer: 'Мастер — он чинит вещи; врач лечит людей, учитель учит.' },
    { id: 'spelling-day1', type: 'text', title: 'Задание 8 — Правописание',
      prompt: 'Напиши:\nврач\nучитель\nмастер\nпомощь\nнавык\n\nВставь буквы:\nвр_ч\nучит_ль\nмаст_р\nпом_щь\nна_ык',
      ruPrimaryText: 'Правописание.', enHelpText: 'Spelling.', answer: 'врач, учитель, мастер, помощь, навык.' },
    { id: 'creative-my-profession-card', type: 'text', title: 'Задание 9 — Моя карточка профессии',
      prompt: 'Сделай карточку одной профессии.\nПрофессия: ______.\nЧто делает: ______.\nЧем помогает людям: ______.\nНарисуй человека этой профессии.',
      ruPrimaryText: 'Творческая карточка.', enHelpText: 'Creative profession card.', answer: 'Карточка с профессией, действием, пользой и рисунком.' },
    { id: 'speech-day1', type: 'text', title: 'Задание 10 — Объясни родителю',
      prompt: 'Скажи родителю по-русски:\nВрач лечит людей.\nУчитель учит детей.\nМастер чинит вещи.\nКаждая профессия даёт пользу.',
      ruPrimaryText: 'Устное объяснение.', enHelpText: 'Explain to parent.', answer: 'Accept if in Russian.' }
  ],
  notebookInstructions: [
    'Если нет принтера:',
    '1. Напиши слова темы в тетради.',
    '2. Прочитай фразы.',
    '3. Реши все задачи по шагам.',
    '4. Сделай карточку профессии.',
    '5. Объясни родителю.'
  ],
  printWorksheet: {
    title: 'Профессии и помощники / Professions and Helpers',
    subtitle: 'Неделя 7 · День 1 / Week 7 · Day 1',
    pages: [
      { title: 'Маршрут и математика / Route and Math', blocks: [
        { type: 'text', text: 'Имя: __________________________   Дата: __________________________' },
        { type: 'text', text: 'Миссия: Анита узнаёт, кто и как помогает людям.' },
        { type: 'text', text: 'Задание 1 — Слова темы:' },
        { type: 'list', items: ['профессия', 'врач', 'учитель', 'мастер', 'помощь', 'навык'] },
        { type: 'text', text: 'Задание 2 — Маленькое чтение. Отметь после чтения:' },
        { type: 'list', items: ['□ Врач лечит людей.', '□ Учитель учит детей.', '□ Мастер чинит вещи.', '□ Каждая профессия даёт пользу.'] },
        { type: 'text', text: 'Задание 3 — Мастерская помощников. Соотнеси профессию (врач, учитель, мастер) и ситуацию:' },
        { type: 'list', items: ['1. Ребёнок болеет — __________', '2. Трудно с уроками — __________', '3. Сломался велосипед — __________'] },
        { type: 'text', text: 'Задание 4 — Помощь дома, школе, друзьям. Реши по шагам:' },
        { type: 'text', text: 'Анита помогла: дом 18 мин, школа 22 мин, друзья 15 мин. Час = 60 минут.' },
        { type: 'list', items: ['Всего: 18 + 22 + 15 = ______', 'Осталось за час: 60 − ______ = ______'] },
        { type: 'text', text: 'Задание 5 — Время работы помощника. Реши по шагам:' },
        { type: 'text', text: 'Мастер чинит 4 велосипеда по 7 минут; с Анитой на 5 минут короче.' },
        { type: 'list', items: ['Без помощи: 4 × 7 = ______', 'С помощью: ______ − 5 = ______'] },
        { type: 'text', text: 'Задание 6 — 3 профессии по 6 карточек. Реши по шагам:' },
        { type: 'text', text: 'Анита делает 3 профессии по 6 карточек; всего у Нимни 36 карточек: 1/3 — врач, 1/4 — учитель, остальные — мастер.' },
        { type: 'list', items: ['3 × 6 = ______', '36 ÷ 3 = ______ (врач)', '36 ÷ 4 = ______ (учитель)', '36 − ______ − ______ = ______ (мастер)'] }
      ] },
      { title: 'Русский и защита / Russian and Defense', blocks: [
        { type: 'text', text: 'Задание 7 — Логика: сломался велосипед. Кого позвать первым и почему? Ответь 1–3 предложениями.' },
        { type: 'text', text: 'Ответ: __________________________________________________________________' },
        { type: 'text', text: 'Задание 8 — Правописание:' },
        { type: 'list', items: ['врач   учитель   мастер   помощь   навык', 'вр_ч   учит_ль   маст_р   пом_щь   на_ык'] },
        { type: 'text', text: 'Задание 9 — Моя карточка профессии:' },
        { type: 'list', items: ['Профессия: ____________________', 'Что делает: ____________________', 'Чем помогает людям: ____________________', 'Рисунок: ____________________'] },
        { type: 'text', text: 'Задание 10 — Объясни родителю. Скажи по-русски:' },
        { type: 'list', items: ['□ Врач лечит людей.', '□ Учитель учит детей.', '□ Мастер чинит вещи.', '□ Каждая профессия даёт пользу.'] },
        { type: 'text', text: 'Parent Check: □ слова  □ фразы  □ мастерская  □ math tasks  □ логика  □ правописание  □ карточка  □ объяснение.' },
        { type: 'text', text: 'Notebook Mode fallback: если нет принтера, сделай все задания в тетради.' }
      ] }
    ]
  },
  parentGuide: {
    goal: 'Grade-3 математика + понимание пользы профессий.',
    mathGoal: 'Умножение, деление, сложение, вычитание, дроби 1/3 и 1/4.',
    russianGoal: 'Прочитать 6 слов и 4 фразы, написать 5 слов.',
    readingWritingGoal: 'Карточка профессии + логическое рассуждение.',
    practicalGoal: 'Связать профессию, действие и пользу.',
    whatThisLessonTeaches: 'Разные профессии дают разную пользу.',
    keyMessage: 'Пользу создают навыки и честная работа, а не название профессии.',
    howToExplain: 'Скажите: «Профессия — это дело, а навык — умение».',
    exampleDialogue: 'Parent: Кто чинит велосипед?\nChild: Мастер.\nParent: А кто учит?\nChild: Учитель.',
    readingSupport: 'Читайте по слогам «учитель» и «профессия».',
    russianSpeechGoal: 'Анита говорит одну фразу про каждую профессию.',
    parentTheoryCard: {
      title: 'Как объяснить профессии',
      purpose: 'Помочь родителю показать пользу разных профессий.',
      keyMessage: 'Каждая профессия — это польза для людей.',
      parentScript: ['«Мастер чинит.»', '«Врач лечит.»', '«Учитель учит.»'],
      practiceSteps: ['Назовите профессию.', 'Спросите: «Кому помогает?»', 'Попросите Аниту сказать по-русски.'],
      doNotSay: ['Не сравнивайте профессии как «лучше/хуже».', 'Не обсуждайте зарплаты.'],
      paperOnlyNotes: ['Все задания — на бумаге, ни к каким реальным клиентам не обращаемся.']
    },
    mathAnswerKey: 'help-home-school-friends: 18 + 22 + 15 = 55; 60 − 55 = 5 минут. helper-work-time: 4 × 7 = 28; 28 − 5 = 23 минуты. three-professions-cards: 3 × 6 = 18; 36 ÷ 3 = 12; 36 ÷ 4 = 9; 36 − 12 − 9 = 15.',
    spellingAnswerKey: 'врач\nучитель\nмастер\nпомощь\nнавык',
    answerKey: [
      { taskId: 'reading-words', answer: 'Попытка чтения слов.' },
      { taskId: 'reading-sentences', answer: 'Попытка чтения фраз.' },
      { taskId: 'workshop-helpers', answer: '1) врач. 2) учитель. 3) мастер.' },
      { taskId: 'help-home-school-friends', answer: '18 + 22 + 15 = 55; 60 − 55 = 5.' },
      { taskId: 'helper-work-time', answer: '4 × 7 = 28; 28 − 5 = 23.' },
      { taskId: 'three-professions-cards', answer: '3 × 6 = 18; 36 ÷ 3 = 12; 36 ÷ 4 = 9; 36 − 12 − 9 = 15.' },
      { taskId: 'logic-broken-bike', answer: 'Мастер: он чинит вещи.' },
      { taskId: 'spelling-day1', answer: 'врач, учитель, мастер, помощь, навык.' },
      { taskId: 'creative-my-profession-card', answer: 'Карточка профессии с действием и пользой.' },
      { taskId: 'speech-day1', answer: 'Объяснение родителю по-русски.' }
    ],
    check: [
      'Анита прочитала слова и фразы.',
      'Анита соотнесла профессии и ситуации.',
      'Анита решила math tasks.',
      'Анита сделала карточку профессии.',
      'Анита объяснила пользу родителю.'
    ],
    spellingCheck: 'Проверить: врач, учитель, мастер, помощь, навык.',
    readingCheck: 'Попытка русского чтения важнее скорости.',
    practicalCheck: 'Анита называет профессию, действие и пользу.',
    drawingCriteria: 'Карточка содержит профессию, действие и пользу.',
    commonMistakes: [
      '«Профессия — только название.» Правильно: «Профессия = польза + навык».',
      '«Мастер = врач.» Правильно: «Мастер чинит вещи, врач лечит людей.»'
    ],
    discussionPrompts: [
      'Какая профессия помогает тебе?',
      'Какой навык ты уже тренируешь?',
      'Кого позвать, если сломалась игрушка?'
    ],
    ifEasy: 'Придумать 4-ю профессию для города Нимни.',
    ifDifficult: 'Оставить 2 профессии: врач и учитель.',
    rewardGuidance: 'Базовая награда — 3 нима, бонусы за ясное объяснение.',
    tokenReward: 'Нимы — это призовые токены курса, а не оплата.',
    parentOnlyNotes: 'Не обсуждать реальные зарплаты, вакансии и деньги за работу. Всё — учебная модель Нимни.',
    safetyNotes: 'Не связываться с реальными клиентами, работодателями и незнакомыми людьми. Все задания — на бумаге.'
  },
  reward: { unit: 'nim', unitName: 'ним', base: 3, max: 5, label: 'Награда за миссию', display: '3 нима',
    bonuses: [
      { id: 'clear-benefit', label: 'Бонус за ясное объяснение пользы', amount: 1 },
      { id: 'neat-card', label: 'Бонус за аккуратную карточку', amount: 1 }
    ] },
  completionRequirements: {
    requiredTaskIds: ['reading-words', 'reading-sentences', 'workshop-helpers', 'help-home-school-friends', 'helper-work-time', 'three-professions-cards', 'logic-broken-bike', 'spelling-day1', 'creative-my-profession-card', 'speech-day1'],
    allowNotebookCompletion: true
  },
  nextLessonId: 'anita-week-7-day-2'
};

export default day1;
